import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import usePortalQuery from 'src/Libs/api/hooks/use-portal-query'
import { getInstallationExtensionsStates } from '../../apis/installation-extensions.api'
import { InstallationExtensionsModel } from '../../models/installation-extensions.model'
import { ExtensionStates, ExtensionTypes } from '../../types'

interface InstallationExtensionsHook {
  loadInstallationExtensionStates: () => Promise<void>
  installationExtensionsState: InstallationExtensionsModel[]
  isLoading: boolean
  isActiveExtensionAvailable?: boolean
}

/**
 * This Hook handles all extensions for a installation
 * @returns the state of all installation extensions
 */
const useInstallationExtensionData = (installationId?: string): InstallationExtensionsHook => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isLoading, refetch } = usePortalQuery({
    queryKey: ['installationExtensions', installationId],
    enabled: !!installationId,
    queryFn: () => getInstallationExtensionsStates(Number(installationId), authFetch),
  })

  const handleRefetch = async (): Promise<void> => {
    refetch()
  }

  const isActiveExtensionAvailable = data
    ?.filter(
      extension =>
        extension.extension === ExtensionTypes.OStrom ||
        extension.extension === ExtensionTypes.Tibber ||
        extension.extension === ExtensionTypes.LuoxTwo
    )
    .some(extension => extension.state === ExtensionStates.Active)

  return { loadInstallationExtensionStates: handleRefetch, installationExtensionsState: data ?? [], isLoading, isActiveExtensionAvailable }
}

export default useInstallationExtensionData
